var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000018236165417111014450000011795408253812575670_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AUDIO"
  }, /*#__PURE__*/React.createElement("g", {
    id: "File"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m302.2 0h-191.1c-18.4 0-33.4 15-33.4 33.5v445.1c0 18.5 15 33.4 33.5 33.5h335.5c18.5 0 33.4-15 33.5-33.5l-1-330.6z",
    fill: "#4eb3f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.2 0-.5 144.5s.5 3.5 3.5 3.5h174z",
    fill: "#07c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m45.5 246.7h337.6c7.5 0 13.6 6.1 13.6 13.6v150.8c0 7.5-6.1 13.6-13.6 13.6h-337.6c-7.5 0-13.6-6.1-13.6-13.6v-150.8c0-7.5 6.1-13.6 13.6-13.6z",
    fill: "#07c"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.4 360.3h-24.9l-3.4 11.7h-22.3l26.6-70.8h23.9l26.6 70.8h-23zm-4.6-15.3-7.8-25.5-7.7 25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m166.5 301.2h21.8v42.2c0 4-.7 8-2 11.9-1.3 3.7-3.4 7-6.1 9.8-2.5 2.6-5.5 4.6-8.8 5.9-4.9 1.7-10.1 2.5-15.3 2.4-3.8 0-7.5-.3-11.3-.7-3.6-.3-7-1.3-10.2-2.9-2.9-1.5-5.4-3.6-7.5-6.1-2.1-2.4-3.7-5.1-4.7-8.2-1.2-3.9-1.9-7.9-2-12v-42.1h21.8v43.2c0 3.9 1.1 6.9 3.2 9s5.1 3.2 8.9 3.3c3.8 0 6.7-1.1 8.9-3.2 2.1-2.1 3.2-5.2 3.2-9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.1 301.2h32.5c6.4 0 11.6.9 15.5 2.6 3.8 1.6 7.2 4.2 9.8 7.5 2.6 3.4 4.5 7.2 5.6 11.4 1.2 4.5 1.8 9.1 1.7 13.7 0 7.6-.9 13.4-2.6 17.6-1.6 4-4 7.6-7.2 10.5-2.8 2.7-6.2 4.6-9.9 5.6-4.2 1.2-8.6 1.9-13 1.9h-32.5zm21.9 16v38.7h5.4c4.6 0 7.8-.5 9.8-1.5 2.1-1.2 3.7-3.1 4.5-5.3 1.1-2.5 1.6-6.6 1.6-12.3 0-7.5-1.2-12.6-3.7-15.4-2.4-2.8-6.5-4.1-12.2-4.1h-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.6 301.2h21.9v70.8h-21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.5 336.6c0-11.6 3.2-20.6 9.7-27s15.4-9.7 26.9-9.7c11.8 0 20.9 3.2 27.2 9.5s9.6 15.2 9.6 26.6c0 8.3-1.4 15-4.2 20.4-2.7 5.2-6.9 9.5-12.1 12.4-5.3 2.9-11.8 4.4-19.7 4.4-8 0-14.6-1.3-19.8-3.8-5.4-2.7-9.8-6.9-12.7-12.1-3.3-5.5-4.9-12.4-4.9-20.7zm21.8.2c0 7.1 1.3 12.3 4 15.4s6.7 4.9 10.9 4.7c4.7 0 8.3-1.5 10.9-4.6s3.9-8.5 3.8-16.5c0-6.7-1.3-11.5-4-14.6s-6.3-4.6-10.9-4.6c-4.1-.2-8 1.6-10.6 4.7-2.7 3.1-4.1 8.2-4.1 15.5z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.8a93c270c0a0bcd49a6000c4477d38be.svg";
export { ForwardRef as ReactComponent };